export default "__VITE_ASSET__C2FBu57O__"